let currentActiveEl = null;

export function setCurrentActiveEl(el) {
    currentActiveEl = el;
}

export function getCurrentActiveEl() {
    return currentActiveEl;
}
